import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { PRIVATE_ROLES } from '../utils/roles';

const ProtectedRoute = ({ requiredRole = null, roles = PRIVATE_ROLES }) => {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  if (roles.length > 0 && !roles.includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
